import { DesignToolsConfig } from '../config/config.schema';

const createShopConfig = (domain: string) => ({
  baseUrl: {
    bucketStorage: `https://media.${domain}`,
    mainDomainUrl: `${domain}`,
    floorImageUrl: `https://scripts.${domain}/preview3d/floor.jpeg`,
    s3BucketStorage: `https://design-tools-storage-qa.s3-accelerate.amazonaws.com`,
    restApi: `https://api.${domain}/api/design-store`,
  },
});
export const qaEnv: DesignToolsConfig = {
  stage: 'qa',
  shops: {
    ex: createShopConfig('qa.truetale.io'),
    mi: createShopConfig('qa.truetale.io'),
    vt: createShopConfig('qa.truetale.io'),
    ap: createShopConfig('qa.truetale.io'),
  },
};
